import React, {useState, useEffect} from 'react';
import SelectInterface from '../forms/SelectInterface.js';
import EmployeeInterface from './interface.js';
import api from '../../api/index.js';
import {ChainSorter} from 'chainsorter';


const EmployeeInterfaceWrapper = (props) => {
	return React.createElement(EmployeeInterface, {
		...props.data.source,
		onAdded: props.onSubmit,
		onUpdated: props.onSubmit
	});
}

// Refresh data on save or edit
// Maybe this should listen for an event?
const EmployeeSelector = (props) => {

	const [employees, setEmployees] = useState(false);

	const refresh = async () => {
		try {
			// If it has changed, it'll already have been invalidated so getsoft() is safe here
			let data = await api.getsoft('employees');  
			setEmployees(ChainSorter(data).desc('LastName', 'FirstName').sort());
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	useEffect(() => {
		if (employees === false) { 
			refresh();
		}

		// If employees have changed, refresh the data
		api.addEventListener('employee.change', refresh);
		return ()=>{
			api.removeEventListener('employee.change', refresh);
		}
	});


	const onChange = (e) => {
		if (props.onChange)
			props.onChange(e.value);
	}
	
	const onEditSubmit = (e) => {
		api.call('employee.change'); // The data has changed - refresh it (for all of them)
		return true;
	}
	
	const onAddSubmit = (e) => {
		api.call('employee.change'); // The data has changed - refresh it (for any visible)
		return true;
	}
	
	const id2value = (id) => {
		if (employees) {
			for(let i=0; i < employees.length; i++) {
				if (employees[i].EmployeeID === id)
					return {
						'value': employees[i].EmployeeID,
						'label': employees[i].FirstName + ' ' + employees[i].LastName,
						'source': employees[i],
					};
			}
		}
		return {};
	}

	// The Employee Interface doesn't load data from the API so we need to send the data in.. But how??
	return <SelectInterface 
		placeholder={props.placeholder || "Employee"}
		onEditSubmit={onEditSubmit}
		onAddSubmit={onAddSubmit}
		value={id2value(props.employee)}
		options={employees ? employees.map((a)=>{return { 
			'value':  a.EmployeeID,
			'label': a.FirstName + ' ' + a.LastName,
			'source': a
		}}) : []}
		type={"Employee"}
		onChange={onChange}
		editForm={EmployeeInterfaceWrapper}
		addForm={EmployeeInterfaceWrapper}
	/>

}
export default EmployeeSelector;